import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '@ui-kit/buttons/button/button.component';

@Component({
    selector: 'btn-cancel',
    standalone: true,
    imports: [ButtonComponent],
    templateUrl: './button-cancel.component.html',
    styleUrl: './button-cancel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCancelComponent {
    id = input.required<string>();
    disabled = input<boolean>(false);

    label = input<string>('uiKit.buttons.buttonCancel.label');
    text = input<boolean>(false);
    severity = input<'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast'>(
        'secondary'
    );
    size = input<undefined | 'small' | 'large'>(undefined);

    onClick = output<MouseEvent>();
}
